import { PrivacyBlockQuote } from 'containers/Drawers/PrivacyPolicyMenuDrawer/styles';
import { Block } from 'pages/policy/Complete/styles';
import { Flex, Table, Typography } from 'front-commons/ds';
import { TablePolicy } from './components/TablePolicy';

export const policyContents = [
	{
		value: 'hympar',
		label: 'Hympar',
		items: [
			{
				label: 'Objetivo',
				content: (
					<Block>
						<Typography>
							Este Aviso de Privacidade (“Aviso”) foi desenvolvido de acordo com a Lei Geral de Proteção de Dados (Lei
							Federal nº 13.709/2018 – “LGPD”) e tem como objetivo apresentar informações sobre o tratamento de dados
							pessoais no âmbito do <Typography variant="Paragraph/Semibold">Portal Hympar</Typography> (“Portal” ou
							“Hympar”) e do <Typography variant="Paragraph/Semibold">Programa de Fidelidade Boni</Typography>{' '}
							(“Programa Boni” ou “Programa”).
						</Typography>
						<Typography>
							O Portal Hympar é desenvolvido e gerenciado pela{' '}
							<Typography variant="Paragraph/Semibold">Hypera S.A.</Typography>, pessoa jurídica inscrita no CNPJ/MF sob
							o nº 02.932.074/0006-04, com sede na Avenida Magalhães de Castro, nº 4.800, 24º andar, cj. 241, Cidade
							Jardim, São Paulo/SP, CEP 05502-001 (“Hypera” ou “Nós”).
						</Typography>
						<Typography>
							Em caso de dúvidas relacionadas aos termos desse Aviso, entre em contato com o Encarregado pelo Tratamento
							de Dados Pessoais da Hypera:
						</Typography>
						<Flex
							raw={{
								'[role="cell"]:not(:last-child)': {
									border: '1px solid var(--border-primary)',
									borderWidth: '0 1px 0px 0',
								},
								'[role="cell"]': {
									padding: '8px 4px 8px 0',
								},
								'[role="columnheader"]': {
									display: 'none',
								},
								'[role="row"]': {
									padding: '0 0 0 10px',
								},
							}}
						>
							<Table
								disableFloatingColumn
								columns={{}}
								rows={[
									{
										col1: <Typography variant="Paragraph/Semibold">Nome</Typography>,
										col2: 'Juliana Aguinaga Damião',
									},
									{
										col1: <Typography variant="Paragraph/Semibold">Encarregado substituto</Typography>,
										col2: 'Paulo Rodrigues Busse',
									},
									{
										col1: <Typography variant="Paragraph/Semibold">Contato</Typography>,
										col2: (
											<Typography variant="Paragraph/Underline">
												<a href="mailto:dpo@hypera.com.br">dpo@hypera.com.br</a>
											</Typography>
										),
									},
								]}
								templateColumns="1fr 1fr"
							/>
						</Flex>
					</Block>
				),
			},
			{
				label: 'O que é o Hympar?',
				content: (
					<Block>
						<Typography>
							O Hympar é uma plataforma online de e-commerce que permite que farmácias cadastradas adquiram produtos da
							Hypera, bem como de outros fornecedores cadastrados, a partir dos principais distribuidores do mercado,
							com condições especiais.
						</Typography>
					</Block>
				),
			},
			{
				label: 'O que é o Programa Boni?',
				content: (
					<Block>
						<Typography>
							O Programa Boni tem como objetivo oferecer benefícios às farmácias cadastradas que realizam compras de
							produtos por meio do Portal.
						</Typography>
						<Typography>
							Para informações completas sobre as regras, critérios de participação e benefícios do Programa, consulte o
							Regulamento do Programa Boni.
						</Typography>
					</Block>
				),
			},
			{
				label: 'Como os dados pessoais são coletados?',
				content: (
					<Block>
						<Typography>
							<Typography variant="Paragraph/Semibold">Fornecidos diretamente pelo titular</Typography>, por exemplo,
							durante o processo de compra de produtos disponíveis no Portal, ou por meio de interações com a Hypera;
						</Typography>
						<Typography>
							<Typography variant="Paragraph/Semibold">Fornecidos por terceiros</Typography>, como farmácias
							cadastradas, com a finalidade de viabilizar a compra pelo titular no Portal e participação das ações do
							Programa Boni;
						</Typography>
						<Typography>
							<Typography variant="Paragraph/Semibold">Coletados de forma automática</Typography>, a partir da navegação
							e do uso das funcionalidades do Portal.
						</Typography>
					</Block>
				),
			},
			{
				label: 'Quais dados pessoais coletamos?',
				content: (
					<Block>
						<Flex
							raw={{
								'[role="cell"]:not(:last-child)': {
									border: '1px solid var(--border-primary)',
									borderWidth: '0 1px 0px 0',
								},
								'[role="cell"]:nth-child(2) ul li::before': {
									position: 'static',
									marginRight: '6px',
								},
								'[role="cell"]': {
									padding: '8px 4px 8px 0',
								},
								'[role="cell"] ul li': {
									paddingLeft: '0',
								},
								'[role="columnheader"]': {
									padding: '0 0 0 10px',
								},
								'[role="row"]': {
									padding: '0 0 0 10px',
								},
							}}
						>
							<Table
								whiteSpaceRow="normal"
								disableFloatingColumn
								columns={{
									col1: {
										name: 'Categoria',
									},
									col2: {
										name: 'Descrição dos dados pessoais',
									},
								}}
								rows={[
									{
										col1: <Typography variant="Paragraph/Semibold">Dados cadastrais</Typography>,
										col2: (
											<ul>
												<li>
													<Typography>Nome;</Typography>
												</li>
												<li>
													<Typography>CPF;</Typography>
												</li>
												<li>
													<Typography>RG;</Typography>
												</li>
												<li>
													<Typography>Endereço;</Typography>
												</li>
												<li>
													<Typography>Ocupação/ ramo de atividade;</Typography>
												</li>
												<li>
													<Typography>Data de nascimento;</Typography>
												</li>
												<li>
													<Typography>E-mail;</Typography>
												</li>
												<li>
													<Typography>Telefone celular;</Typography>
												</li>
												<li>
													<Typography>Informações da(s) farmácia(s) vinculadas, quando aplicável.</Typography>
												</li>
											</ul>
										),
									},
									{
										col1: <Typography variant="Paragraph/Semibold">Dados comportamentais</Typography>,
										col2: (
											<ul>
												<li>
													<Typography>Produtos favoritos;</Typography>
												</li>
												<li>
													<Typography>Hobbies;</Typography>
												</li>
												<li>
													<Typography>Interesses;</Typography>
												</li>
												<li>
													<Typography>Estilo de vida.</Typography>
												</li>
											</ul>
										),
									},
									{
										col1: <Typography variant="Paragraph/Semibold">Dados de compras</Typography>,
										col2: (
											<ul>
												<li>
													<Typography>Produtos adquiridos e quantidades;</Typography>
												</li>
												<li>
													<Typography>Data e hora da compra;</Typography>
												</li>
												<li>
													<Typography>Valor total;</Typography>
												</li>
												<li>
													<Typography>Forma de pagamento;</Typography>
												</li>
												<li>
													<Typography>Endereço de entrega.</Typography>
												</li>
											</ul>
										),
									},
									{
										col1: (
											<Typography variant="Paragraph/Semibold">
												Dados eletrônicos, coletados automaticamente a partir do uso do Portal
											</Typography>
										),
										col2: (
											<ul>
												<li>
													<Typography>Endereço IP;</Typography>
												</li>
												<li>
													<Typography>ID de dispositivos móveis;</Typography>
												</li>
												<li>
													<Typography>Navegadores utilizados;</Typography>
												</li>
												<li>
													<Typography>Data e hora de acesso ao Portal;</Typography>
												</li>
												<li>
													<Typography>Tempo de acesso;</Typography>
												</li>
												<li>
													<Typography>Número de “cliques”.</Typography>
												</li>
											</ul>
										),
									},
									{
										col1: <Typography variant="Paragraph/Semibold">Dados do Programa Boni</Typography>,
										col2: (
											<ul>
												<li>
													<Typography>Performance;</Typography>
												</li>
												<li>
													<Typography>Metas individuais;</Typography>
												</li>
												<li>
													<Typography>Indicadores de desempenho;</Typography>
												</li>
												<li>
													<Typography>Pontuações.</Typography>
												</li>
											</ul>
										),
									},
								]}
								templateColumns="1fr 1fr"
							/>
						</Flex>
					</Block>
				),
			},
			{
				label: 'Quais as finalidades e hipóteses legais que motivam o tratamento?',
				content: (
					<Block>
						<Typography>
							Para viabilizar o correto funcionamento do Portal, realizamos o tratamento de dados pessoais dos usuários
							vinculados às farmácias cadastradas. No quadro abaixo apresentamos quais dados pessoais são tratados para
							uso do Portal, as finalidades e hipóteses legais que embasam o tratamento:
						</Typography>
						<TablePolicy
							columns={['Finalidade', 'Dados tratados', 'Hipótese legal']}
							rows={[
								[
									{
										content:
											'Permitir a compra de produtos, validar a identidade do responsável pela farmácia e viabilizar a participação em programas de fidelidade da Hypera',
									},
									{ content: 'Dados cadastrais' },
									{
										content:
											'Legítimo interesse (art. 7º, IX da LGPD), com a finalidade de garantir o acesso e a utilização do Portal e do Programa pelos representantes das farmácias',
										rowSpan: 7,
									},
								],
								[
									{
										content:
											'Analisar seu perfil e hábitos de consumo para personalizar e melhorar sua experiência em nossos sites e aplicativos',
									},
									{ content: 'Dados cadastrais, dados de compras e dados comportamentais' },
									null,
								],
								[
									{
										content:
											'Identificar e autenticar os usuários para acesso ao Portal e ao Programa, permitir o acúmulo de pontos, acompanhar metas, desempenho, pontuações e pedidos de resgate, e viabilizar o resgate de prêmios',
									},
									{ content: 'Dados cadastrais e dados do Programa Boni' },
									null,
								],
								[
									{ content: 'Processar pedidos, faturar e viabilizar a entrega dos produtos' },
									{ content: 'Dados cadastrais e dados de compras' },
									null,
								],
								[
									{
										content:
											'Atender solicitações, chamados e dúvidas sobre o Portal e o Programa, e enviar comunicações sobre produtos, serviços e o Programa Boni por meio do Portal, SMS, WhatsApp e e-mail',
									},
									{ content: 'Dados cadastrais, dados de compras e dados comportamentais' },
									null,
								],
								[
									{ content: 'Prevenir a ocorrência de fraudes e/ou demais atitudes ilícitas' },
									{ content: 'Dados cadastrais e dados eletrônicos' },
									null,
								],
								[
									{
										content:
											'Permitir a melhoria técnica contínua do Portal, corrigindo erros e adaptando o conteúdo aos dispositivos mais utilizados pelo usuário',
									},
									{ content: 'Dados eletrônicos' },
									null,
								],
								[
									{ content: 'Permitir o exercício de direitos em demandas judiciais, administrativas ou arbitrais' },
									{ content: 'Dados cadastrais, dados eletrônicos e dados do Programa Boni' },
									{ content: 'Exercício regular de direitos (art. 7º, VI da LGPD)' },
								],
								[
									{ content: 'Cumprir com obrigações legais e regulatórias impostas à Hypera' },
									{ content: 'Dados cadastrais, dados eletrônicos e dados do Programa Boni' },
									{ content: 'Cumprimento de obrigação legal ou regulatória (art. 7º, II da LGPD)' },
								],
							]}
						/>
						<Typography>
							Para além dessas situações, algumas informações também poderão ser utilizadas de forma anonimizada (ou
							seja, de maneira que não leve à sua identificação), com a finalidade de produzir relatórios estatísticos
							sobre o funcionamento do Portal e sobre o desempenho dos produtos do portfólio da Hypera.
						</Typography>
					</Block>
				),
			},
			{
				label: 'Informações pessoais de menores de 18 anos',
				content: (
					<Block>
						<Typography>
							A Hypera não coleta, armazena ou trata dados pessoais de menores de 18 anos. Toda a interação no Portal e
							no Programa, incluindo o cadastro e a aquisição de produtos é realizada exclusivamente em nome e sob a
							responsabilidade de um responsável legal.
						</Typography>
					</Block>
				),
			},
			{
				label: 'Com quem compartilhamos os seus dados pessoais?',
				content: (
					<Block>
						<Typography>
							Para atender as finalidades acima, podemos compartilhar os dados pessoais coletados no Portal com os
							seguintes destinatários, observando as justificativas legais e os limites aplicáveis:
						</Typography>
						<ul>
							<li>
								<Typography>Distribuidores responsáveis pelo faturamento e entrega dos pedidos realizados;</Typography>
							</li>
							<li>
								<Typography>
									Fornecedores e prestadores de serviços que auxiliam na gestão e funcionamento do Portal;
								</Typography>
							</li>
							<li>
								<Typography>
									Prestador de serviço responsável pelo processo de validação da identidade dos usuários cadastrados;
								</Typography>
							</li>
							<li>
								<Typography>
									No caso de participação no Programa Boni, com parceiros responsáveis pela gestão de pontos e resgate
									de prêmios;
								</Typography>
							</li>
							<li>
								<Typography>
									Fornecedores de produtos comercializados no Portal que não pertencem à Hypera, exclusivamente para
									viabilizar o processamento, o faturamento, a entrega ou o atendimento relacionado a tais produtos,
									conforme aplicável;
								</Typography>
							</li>
							<li>
								<Typography>
									Demais empresas do grupo econômico da Hypera, respeitados os propósitos apresentados nesse Aviso;
								</Typography>
							</li>
							<li>
								<Typography>
									Autoridades competentes para cumprimento de obrigações legais, regulatórias ou para atendimento de
									requisições oficiais.
								</Typography>
							</li>
						</ul>

						<PrivacyBlockQuote>
							<Typography variant="Paragraph/Semibold">Importante:</Typography> Para realizar compras por meio do
							Portal, é necessário que a farmácia também tenha cadastro junto aos distribuidores, pois eles são os
							responsáveis pelo faturamento e entrega dos produtos.{' '}
							<Typography variant="Paragraph/Underline">
								A Hypera não se responsabiliza pelas atividades de tratamento de dados pessoais conduzidas diretamente
								pelos distribuidores.
							</Typography>
						</PrivacyBlockQuote>
					</Block>
				),
			},
			{
				label: 'Por quanto tempo armazenamos seus dados pessoais?',
				content: (
					<Block>
						<Typography>
							Como regra, a Hypera armazena dados pessoais apenas pelo período necessário para atendimento das
							finalidades relacionadas nesse aviso de privacidade, observado o disposto nos artigos 15 e 16 da LGPD. Em
							alguns casos, as informações poderão ser mantidas por período complementar caso necessário para o
							cumprimento de obrigações legais e regulatórias ou para o resguardar o exercício de nossos direitos.
						</Typography>
						<Typography>
							Você pode solicitar mais detalhes sobre períodos de retenção de seus dados por meio do envio de
							solicitação ao canal de contato disponível nesse aviso.
						</Typography>
					</Block>
				),
			},
			{
				label: 'Como protegemos seus dados pessoais?',
				content: (
					<Block>
						<Typography>
							A Hypera armazena os dados pessoais sob rígidos processos de segurança, respeitando as diretrizes de suas
							políticas e procedimentos internos, os quais foram desenvolvidos em observâncias às melhores práticas
							sobre o tema. Nesse sentido, são adotadas medidas de segurança técnicas e organizacionais razoáveis para
							proteger os dados pessoais contra acessos não autorizados e/ou situações acidentais ou ilícitas de
							destruição, perda, alteração, comunicação ou difusão. Tais medidas incluem:
						</Typography>
						<ul>
							<li>
								<Typography>Criptografia dos dados para proteção durante a transmissão e armazenamento.</Typography>
							</li>
							<li>
								<Typography>Antivírus e firewalls.</Typography>
							</li>
							<li>
								<Typography>Realização de backups regulares.</Typography>
							</li>
							<li>
								<Typography>
									Controles de acesso restritos para garantir que apenas pessoas autorizadas possam acessar os dados.
								</Typography>
							</li>
							<li>
								<Typography>Monitoramento contínuo de sistemas para detectar e corrigir vulnerabilidades.</Typography>
							</li>
							<li>
								<Typography>
									Programa de governança em privacidade estruturado, atualizado e aplicado às suas atividades.
								</Typography>
							</li>
							<li>
								<Typography>Políticas de segurança claras e revisadas periodicamente.</Typography>
							</li>
							<li>
								<Typography>
									Estabelecimento de obrigações de confidencialidade e proteção de dados com funcionários, parceiros e
									fornecedores de serviços.
								</Typography>
							</li>
						</ul>
					</Block>
				),
			},
			{
				label: 'Transferência internacional de dados pessoais',
				content: (
					<Block>
						<Typography>
							Os dados pessoais tratados pela Hypera poderão ser objeto de transferência internacional no caso de uso de
							plataformas e servidores de computação em nuvem hospedados em outros países.
						</Typography>
						<Typography>
							A Hypera se preocupa com a proteção dos seus dados pessoais, independentemente de onde estejam e de quem
							os esteja tratando. Nesse sentido, adotamos mecanismos legalmente válidos para realização de
							transferências internacionais, em conformidade com a legislação aplicável, bem como padrões de segurança
							adequados, como a criptografia dos dados em trânsito e em repouso, VPNs e túneis seguros para envio de
							dados e autenticação multifator para acesso aos sistemas.
						</Typography>
					</Block>
				),
			},
			{
				label: 'Como ocorre o tratamento de dados em plataformas de terceiros?',
				content: (
					<Block>
						<Typography>
							Este Aviso de Privacidade não se aplica a plataformas e aplicações de terceiros que possam ser oferecidos
							ou acessados por meio do Portal Hympar, os quais serão regidos por seus respectivos avisos de privacidade.
							Nós não possuímos qualquer responsabilidade ou ingerência sobre a forma como esses terceiros realizam o
							tratamento de seus dados pessoais.
						</Typography>
					</Block>
				),
			},
			{
				label: 'Como utilizamos cookies?',
				content: (
					<Block>
						<Typography>
							<Typography variant="Paragraph/Semibold">Você sabe o que são Cookies?</Typography> Cookies são arquivos
							que permitem a coleta automática de informações quando você visita o Portal Hympar. Através de cookies,
							obtemos dados sobre a sua experiência em nosso Portal.
						</Typography>
						<Typography>
							<Typography variant="Paragraph/Semibold">Por que utilizamos cookies?</Typography> As informações coletadas
							por meio de cookies possibilitam conhecermos melhor os nossos usuários e, consequentemente, orientar
							nossas estratégias de negócio, permitindo, por exemplo, melhorar a experiência em nosso Portal e garantir
							a segurança de nossos usuários.
						</Typography>
						<Typography>
							<Typography variant="Paragraph/Semibold">
								Quais tipos de cookies são utilizados em nosso Portal?
							</Typography>{' '}
							Apesar de existirem diversos tipos de cookies, no Portal Hympar utilizamos apenas aqueles considerados
							como essenciais para funcionamento do Portal, conforme a seguir:
						</Typography>
						<ul>
							<li>
								<Typography>
									<Typography variant="Paragraph/Semibold">Cookies analíticos:</Typography> permitem entender como os
									usuários interagem com o Portal; e
								</Typography>
							</li>
							<li>
								<Typography>
									<Typography variant="Paragraph/Semibold">Cookies de segurança:</Typography> bloqueiam o uso de
									aplicações e/ou ferramentas automatizadas utilizadas para o cometimento de fraudes no Portal.
								</Typography>
							</li>
						</ul>
						<Typography>
							<Typography variant="Paragraph/Semibold">Por quanto tempo os cookies são armazenados?</Typography> Os
							cookies coletados através do Portal são armazenados por 1(Um) ano.
						</Typography>

						<Typography variant="Paragraph/Underline">
							Lembramos que as informações acessadas através dos cookies mantidos em nosso Portal não são compartilhadas
							com terceiros.
						</Typography>
						<Typography>
							<Typography variant="Paragraph/Semibold">Posso bloquear/rejeitar o uso de cookies?</Typography> Sim, é
							possível ajustar as preferências para a coleta de cookies a partir das configurações do navegador de
							internet utilizado para acessar o Portal. No entanto, caso realize o bloqueio de cookies, algumas
							funcionalidades do Portal podem ser prejudicadas. Para gerenciar o uso de cookies, você poderá acessar as
							configurações do seu navegador. Os links a seguir trazem maiores informações sobre esse tema:
						</Typography>
						<ul>
							<li>
								<Typography variant="Paragraph/Underline">
									<a
										href="https://support.mozilla.org/pt-BR/kb/limpe-cookies-e-dados-de-sites-no-firefox"
										target="_blank"
									>
										Firefox
									</a>
								</Typography>
							</li>
							<li>
								<Typography variant="Paragraph/Underline">
									<a
										href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=pt-BR"
										target="_blank"
									>
										Chrome
									</a>
								</Typography>
							</li>
							<li>
								<Typography variant="Paragraph/Underline">
									<a href="https://support.apple.com/pt-br/guide/safari/sfri11471/mac" target="_blank">
										Safari
									</a>
								</Typography>
							</li>
							<li>
								<Typography variant="Paragraph/Underline">
									<a
										href="https://support.microsoft.com/pt-br/topic/como-excluir-arquivos-de-cookie-no-internet-explorer-bca9446f-d873-78de-77ba-d42645fa52fc"
										target="_blank"
									>
										Internet Explorer
									</a>
								</Typography>
							</li>
						</ul>
						<Typography>
							<Typography variant="Paragraph/Semibold">
								Como posso esclarecer eventuais dúvidas sobre o uso de cookies?
							</Typography>{' '}
							Em caso de dúvidas complementares sobre o uso de cookies, você pode entrar em contato conosco através do
							canal disponível nesse Aviso:
							<Typography variant="Paragraph/Underline">
								{' '}
								<a href="mailto:dpo@hypera.com.br">dpo@hypera.com.br</a>.
							</Typography>
						</Typography>
					</Block>
				),
			},
			{
				label: 'Quais os direitos assegurados pela lei geral de proteção de dados?',
				content: (
					<Block>
						<Typography>
							A Lei Geral de Proteção de Dados prevê direitos relacionados ao uso de dados pessoais. São eles:
						</Typography>
						<Flex
							raw={{
								'[role="cell"]:not(:last-child)': {
									border: '1px solid var(--border-primary)',
									borderWidth: '0 1px 0px 0',
								},
								'[role="cell"]': {
									padding: '8px 4px 8px 0',
								},
								'[role="columnheader"]': {
									display: 'none',
								},
								'[role="row"]': {
									padding: '0 0 0 10px',
								},
							}}
						>
							<Table
								whiteSpaceRow="normal"
								disableFloatingColumn
								columns={{}}
								rows={[
									{
										col1: 'Confirmação e acesso aos dados',
										col2: 'O usuário pode solicitar informações sobre os dados tratados no âmbito do Portal e sobre os terceiros que acessam tais dados, bem como solicitar à Hypera o acesso aos seus dados pessoais utilizados.',
									},
									{
										col1: 'Correção ou atualização',
										col2: 'O usuário pode solicitar a correção de informações que estejam desatualizadas, incorretas ou incompletas.',
									},
									{
										col1: 'Eliminação, anonimização ou bloqueio',
										col2: 'O usuário pode solicitar a exclusão, anonimização ou bloqueio de dados pessoais que não sejam mais necessários para o funcionamento do Portal.',
									},
									{
										col1: 'Revogação do consentimento',
										col2: 'Nos casos em que o tratamento ocorrer mediante a obtenção do consentimento (autorização), o usuário pode solicitar revogação dessa autorização e/ou a eliminação de dados pessoais tratados com base nessa autorização.',
									},
									{
										col1: 'Portabilidade',
										col2: 'Uma vez regulamentado pela Autoridade Nacional de Proteção de Dados, o usuário poderá solicitar a portabilidade de seus dados pessoais.',
									},
									{
										col1: 'Oposição',
										col2: 'O usuário pode se opor à utilização de seus dados pessoais, desde que verificado inconformidade com a LGPD e observados os limites e imposições legalmente previstos.',
									},
									{
										col1: 'Informações sobre o compartilhamento',
										col2: 'Sem prejuízo das informações fornecidas neste Aviso, o usuário pode solicitar esclarecimentos adicionais sobre o compartilhamento de seus dados pessoais.',
									},
									{
										col1: 'Consequências de não autorização',
										col2: 'Quando aplicável, o usuário poderá solicitar esclarecimentos sobre as possíveis consequências da não autorização para o uso de seus dados pessoais.',
									},
									{
										col1: 'Transferência internacional de dados',
										col2: 'O usuário poderá solicitar informações adicionais quanto às transferências internacionais realizadas e respectivos mecanismos adotados.',
									},
									{
										col1: 'Revisão de decisões automatizadas',
										col2: 'O usuário pode solicitar a revisão de decisões autônomas (sem participação humana) e/ou o fornecimento dos critérios e procedimentos adotados para a tomada dessas decisões.',
									},
									{
										col1: 'Solicitação junto à autoridade competente',
										col2: 'Caso não seja possível exercer os direitos apresentados nesse tópico junto à Hypera, o usuário poderá encaminhar solicitação à Autoridade Nacional de Proteção de Dados (ANPD).',
									},
								]}
								templateColumns="1fr 3fr"
							/>
						</Flex>
						<Typography>
							O exercício dos direitos relacionados no quadro acima depende de prévia solicitação do usuário e da
							inexistência de qualquer restrição técnica e/ou jurídica.
						</Typography>
						<Typography>
							Caso queira solicitar o exercício dos direitos relacionados ao uso de seus dados pessoais, entre em
							contato com nosso Encarregado por meio do canal:{' '}
							<Typography variant="Paragraph/Underline">
								<a href="mailto:dpo@hypera.com.br">dpo@hypera.com.br</a>
							</Typography>
							.
						</Typography>
					</Block>
				),
			},
			{
				label: 'Atualizações',
				content: (
					<Block>
						<Typography>
							Este Aviso poderá sofrer atualizações e ajustes a qualquer tempo. Caso haja atualização relevante,
							informaremos no Portal.
						</Typography>
						<Typography>
							<Typography variant="Paragraph/Semibold">Data da última atualização:</Typography> 21/07/2025.
						</Typography>
					</Block>
				),
			},
		],
	},
	{
		value: 'boni',
		label: 'Boni',
		items: [
			{
				label: 'Objetivo',
				content: (
					<Block>
						<Typography>
							Este Aviso de Privacidade (“Aviso”) foi desenvolvido de acordo com a Lei Geral de Proteção de Dados (Lei
							Federal nº 13.709/2018 – “LGPD”) e tem como objetivo apresentar informações sobre o tratamento de dados
							pessoais no âmbito do Portal Hympar (“Portal” ou “Hympar”) e do Programa de Fidelidade Boni (“Programa
							Boni” ou “Programa”).
						</Typography>
						<Typography>
							A Portal Hympar é desenvolvido e gerenciado pela Hypera S.A., pessoa jurídica inscrita no CNPJ/MF sob o nº
							02.932.074/0006-04, com sede na Avenida Magalhães de Castro, nº 4.800, 24º andar, cj. 241, Cidade Jardim,
							São Paulo/SP, CEP 05502-001 (“Hypera” ou “Nós”).
						</Typography>
						<Typography>
							Em caso de dúvidas relacionadas aos termos desse Aviso, entre em contato com o Encarregado pelo Tratamento
							de Dados da Hypera:
							<br />
							Nome: João Paulo Mello de Macedo Costa
							<br />
							Contato: <a href="mailto:dpo@hypera.com.br">dpo@hypera.com.br</a>
						</Typography>
					</Block>
				),
			},
			{
				label: 'O que é o Hympar?',
				content: (
					<Block>
						<Typography>
							O Hympar é uma plataforma online de e-commerce que permite que farmácias cadastradas adquiram produtos
							Hypera a partir dos principais distribuidores do mercado, com condições especiais.
						</Typography>
						<Typography>Para saber mais sobre o funcionamento do Portal, acesse os Termos de Uso. </Typography>
					</Block>
				),
			},
			{
				label: 'Quais dados pessoais coletamos e para quais finalidades utilizamos?',
				content: (
					<Block>
						<Typography>
							Para viabilizar o correto funcionamento do Portal, realizamos o tratamento de dados pessoais dos usuários
							vinculados às farmácias cadastradas. No quadro abaixo apresentamos quais dados pessoais são tratados para
							uso do Portal e as respectivas finalidades:
						</Typography>

						<Typography variant="Paragraph/Semibold">Dados coletados:</Typography>
						<Typography>Dados para cadastro do usuário no Portal:</Typography>
						<ul>
							<li>
								<Typography>Nome;</Typography>
							</li>
							<li>
								<Typography>CPF;</Typography>
							</li>
							<li>
								<Typography>E-mail;</Typography>
							</li>
							<li>
								<Typography>Telefone celular;</Typography>
							</li>
							<li>
								<Typography>CNPJ e Razão Social da(s) farmácia(s) à(s) qual(is) o usuário está vinculado.</Typography>
							</li>
						</ul>

						<Typography>Finalidades do tratamento</Typography>
						<ul>
							<li>
								<Typography>
									Permitir que o usuário realize a compra de produtos do portfólio da Hypera para as farmácias às quais
									está vinculado;
								</Typography>
							</li>
							<li>
								<Typography>Validar a identidade do responsável pela farmácia cadastrada;</Typography>
							</li>
							<li>
								<Typography>
									Identificar e autenticar os usuários adequadamente, viabilizando o acesso aos recursos e
									funcionalidades do Portal;
								</Typography>
							</li>
							<li>
								<Typography>Atender solicitações, chamados e dúvidas;</Typography>
							</li>
							<li>
								<Typography>
									Permitir a participação em programas de fidelidade da Hypera para acúmulo de pontos e resgate de
									benefícios;
								</Typography>
							</li>
							<li>
								<Typography>
									Enviar comunicações via WhatsApp sobre compras realizadas, promoções, novidades e outras iniciativas
									relevantes da Hypera;
								</Typography>
							</li>
							<li>
								<Typography>Prevenir a ocorrência de fraudes e/ou demais atitudes ilícitas;</Typography>
							</li>
							<li>
								<Typography>
									Cumprir com obrigações legais ou regulatórias e exercer direitos em demandas judiciais,
									administrativas ou arbitrais.
								</Typography>
							</li>
						</ul>

						<Typography>Informações coletadas automaticamente a partir do uso do Portal, tais como:</Typography>
						<ul>
							<li>
								<Typography>Endereço IP; </Typography>
							</li>
							<li>
								<Typography>ID de dispositivos móveis; </Typography>
							</li>
							<li>
								<Typography>Navegadores utilizados;</Typography>
							</li>
							<li>
								<Typography>Data e hora de acesso ao Portal;</Typography>
							</li>
							<li>
								<Typography>Tempo de acesso;</Typography>
							</li>
							<li>
								<Typography>Número de “cliques”.</Typography>
							</li>
						</ul>

						<Typography>Finalidades do tratamento</Typography>
						<ul>
							<li>
								<Typography>Prevenir a ocorrência de fraudes e/ou demais atitudes ilícitas;</Typography>
							</li>
							<li>
								<Typography>
									Permitir a melhoria técnica contínua do Portal, corrigindo erros e adaptando o conteúdo aos
									dispositivos mais utilizados pelo usuário;
								</Typography>
							</li>
							<li>
								<Typography>Cumprir com obrigações legais e regulatórias de guarda de registros de acesso.</Typography>
							</li>
						</ul>

						<Typography>
							Caso a farmácia participe do Programa Boni, também serão tratados dados para cadastro no Programa (nome,
							CPF, e-mail, data de nascimento e telefone) e informações sobre a performance no Programa, tais como metas
							individuais, indicadores de desempenho e pontuações. Para mais informações sobre o Programa Boni, acesse o
							Regulamento disponível em [<a href="https://bonifidelidade.com.br">www.bonifidelidade.com.br</a>].
						</Typography>

						<Typography>Finalidades do tratamento</Typography>
						<ul>
							<li>
								<Typography>
									Identificar e autenticar o participante, viabilizando o acesso aos benefícios do Programa;
								</Typography>
							</li>
							<li>
								<Typography>Permitir o acúmulo de pontos no Programa;</Typography>
							</li>
							<li>
								<Typography>
									Realizar o acompanhamento de metas, desempenho, pontuações e pedidos de resgates;
								</Typography>
							</li>
							<li>
								<Typography>Permitir o resgate de prêmios;</Typography>
							</li>
							<li>
								<Typography>Atender solicitações, chamados e dúvidas;</Typography>
							</li>
							<li>
								<Typography>Prevenir a ocorrência de fraudes e/ou demais atitudes ilícitas;</Typography>
							</li>
							<li>
								<Typography>
									Enviar comunicações diversas, inclusive comunicados sobre o Programa e anúncios e promoções sobre
									produtos e iniciativas relevantes da Hypera.
								</Typography>
							</li>
						</ul>

						<Typography>
							Para além dessas situações, algumas informações também poderão ser utilizadas de forma anonimizada (ou
							seja, de maneira que não leve à sua identificação), com a finalidade de produzir relatórios estatísticos
							sobre o funcionamento do Portal e sobre o desempenho dos produtos do portfólio da Hypera.
						</Typography>
					</Block>
				),
			},
			{
				label: 'Com quem compartilhamos os seus dados pessoais?',
				content: (
					<Block>
						<Typography>
							Para atender as finalidades acima, podemos compartilhar os dados pessoais coletados no Portal com os
							seguintes destinatários, observando as justificativas legais e os limites aplicáveis:
						</Typography>

						<ul>
							<li>Distribuidores responsáveis pelo faturamento e entrega dos pedidos realizados;</li>
							<li>Fornecedores e prestadores de serviços que auxiliam na gestão e funcionamento do Portal;</li>
							<li>
								Prestador de serviço responsável pelo processo de validação da identidade dos usuários cadastrados;
							</li>
							<li>
								No caso de participação no Programa Boni, com parceiros responsáveis pela gestão de pontos e resgate de
								prêmios;
							</li>
							<li>
								Demais empresas do grupo econômico da Hypera, respeitados os propósitos apresentados nesse Aviso; e
							</li>
							<li>
								Autoridades competentes para cumprimento de obrigações legais, regulatórias ou para atendimento de
								requisições oficiais.
							</li>
						</ul>

						<Typography variant="Paragraph/Regular">
							<strong>Importante:</strong> Para realizar compras por meio do Portal, é necessário que a farmácia também
							tenha cadastro junto aos distribuidores, pois eles são os responsáveis pelo faturamento e entrega dos
							produtos. A Hypera não se responsabiliza pelas atividades de tratamento de dados pessoais conduzidas
							diretamente pelos distribuidores.
						</Typography>
					</Block>
				),
			},
			{
				label: 'Como ocorre o tratamento de dados em plataformas de terceiros?',
				content: (
					<Block>
						<Typography>
							Este Aviso de Privacidade não se aplica a plataformas e aplicações de terceiros que possam ser oferecidos
							ou acessados por meio do Portal Hympar, os quais serão regidos por seus respectivos avisos de privacidade.
							Nós não possuímos qualquer responsabilidade ou ingerência sobre a forma como esses terceiros realizam o
							tratamento de seus dados pessoais.
						</Typography>
					</Block>
				),
			},
			{
				label: 'Como utilizamos cookies?',
				content: (
					<Block>
						<div>
							<Typography variant="Paragraph/Semibold">Você sabe o que são Cookies?</Typography>
							<Typography>
								Cookies são arquivos que permitem a coleta automática de informações quando você visita o Portal Hympar
								Hub. Através de cookies, obtemos dados sobre a sua experiência em nosso Portal.{' '}
							</Typography>
						</div>

						<div>
							<Typography variant="Paragraph/Semibold">Por que utilizamos cookies?</Typography>
							<Typography>
								As informações coletadas por meio de cookies possibilitam conhecermos melhor os nossos usuários e,
								consequentemente, orientar nossas estratégias de negócio, permitindo, por exemplo, melhorar a
								experiência em nosso Portal e garantir a segurança de nossos usuários.{' '}
							</Typography>
						</div>
						<div>
							<Typography variant="Paragraph/Semibold">
								Quais tipos de cookies são utilizados em nosso Portal?
							</Typography>
							<Typography>
								Apesar de existirem diversos tipos de cookies, no Portal Hympar utilizamos apenas aqueles considerados
								como essenciais para funcionamento do Portal, conforme a seguir:{' '}
							</Typography>
						</div>

						<ul>
							<li>
								<Typography>
									<strong>Cookies analíticos:</strong> permitem entender como os usuários interagem com o Portal; e
								</Typography>
							</li>
							<br />
							<li>
								<Typography>
									<strong>Cookies de segurança:</strong> bloqueiam o uso de aplicações e/ou ferramentas automatizadas
									utilizadas para o cometimento de fraudes no Portal.
								</Typography>
							</li>
						</ul>

						<Typography variant="Paragraph/Semibold">
							Por quanto tempo os cookies são armazenados? Não serão coletados
						</Typography>

						<Typography>
							Lembramos que as informações acessadas através dos cookies mantidos em nosso Portal não são compartilhadas
							com terceiros.
						</Typography>

						<div>
							<Typography variant="Paragraph/Semibold">Posso bloquear/rejeitar o uso de cookies?</Typography>

							<Typography>
								Sim, é possível ajustar as preferências para a coleta de cookies a partir das configurações do navegador
								de internet utilizado para acessar o Portal. No entanto, caso realize o bloqueio de cookies, algumas
								funcionalidades do Portal podem ser prejudicadas. Para gerenciar o uso de cookies, você poderá acessar
								as configurações do seu navegador. Os links a seguir trazem maiores informações sobre esse tema:
							</Typography>
						</div>

						<ul>
							<li>
								<Typography>
									<a href="https://support.mozilla.org/pt-BR/kb/limpe-cookies-e-dados-de-sites-no-firefox">Firefox</a>
								</Typography>
							</li>
							<li>
								<Typography>
									<a href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=pt-BR">
										Chrome
									</a>
								</Typography>
							</li>
							<li>
								<Typography>
									<a href="https://support.apple.com/pt-br/guide/safari/sfri11471/mac">Safari</a>
								</Typography>
							</li>
							<li>
								<Typography>
									<a href="https://support.microsoft.com/pt-br/topic/como-excluir-arquivos-de-cookie-no-internet-explorer-bca9446f-d873-78de-77ba-d42645fa52fc">
										Internet Explorer
									</a>
								</Typography>
							</li>
						</ul>

						<Typography variant="Paragraph/Semibold">
							Como posso esclarecer eventuais dúvidas sobre o uso de cookies?
						</Typography>

						<Typography>
							Em caso de dúvidas complementares sobre o uso de cookies, você pode entrar em contato conosco através do
							canal disponível nesse Aviso: <a href="mailto:dpo@hypera.com">dpo@hypera.com</a>.
						</Typography>
					</Block>
				),
			},
			{
				label: 'Quais as medidas de segurança que adotamos e por quanto tempo os dados pessoais são armazenados?',
				content: (
					<Block>
						<Typography>
							Os dados pessoais tratados durante o uso do Portal serão mantidos de forma segura, confidencial e de
							acordo com as regras de segurança da informação da Hypera, garantido o acesso apenas às pessoas que de
							fato necessitem manipulá-los.
						</Typography>

						<Typography>
							Os dados pessoais utilizados no Portal Hympar serão mantidos pelo período necessário para execução das
							finalidades descritas nesse Aviso, observados, inclusive, os prazos legais e regulatórios de guarda das
							informações e a eventual necessidade de utilização em processos judiciais, administrativos ou arbitrais.
						</Typography>
					</Block>
				),
			},
			{
				label: 'Quais os direitos assegurados pela Lei Geral de Proteção de Dados?',
				content: (
					<Block>
						<Typography>
							A Lei Geral de Proteção de Dados prevê direitos relacionados ao uso de dados pessoais. São eles:
						</Typography>

						<ul>
							<li>
								<Typography>
									<strong>Confirmação e acesso aos dados:</strong> O usuário pode solicitar informações sobre os dados
									tratados no âmbito do Portal e sobre os terceiros que acessam tais dados, bem como solicitar à Hypera
									o acesso aos seus dados pessoais utilizados.
								</Typography>
							</li>

							<li>
								<Typography>
									<strong>Correção ou atualização:</strong> O usuário pode solicitar a correção de informações que
									estejam desatualizadas, incorretas ou incompletas.
								</Typography>
							</li>
							<li>
								<Typography>
									<strong>Eliminação, anonimização ou bloqueio:</strong> O usuário pode solicitar a exclusão,
									anonimização ou bloqueio de dados pessoais que não sejam mais necessários para o funcionamento do
									Portal.
								</Typography>
							</li>
							<li>
								<Typography>
									<strong>Revogação do consentimento:</strong> Nos casos em que o tratamento ocorrer mediante a obtenção
									do consentimento (autorização), o usuário pode solicitar revogação dessa autorização e/ou a eliminação
									de dados pessoais tratados com base nessa autorização.
								</Typography>
							</li>
							<li>
								<Typography>
									<strong>Portabilidade:</strong> Uma vez regulamentado pela Autoridade Nacional de Proteção de Dados, o
									usuário poderá solicitar a portabilidade de seus dados pessoais.
								</Typography>
							</li>
							<li>
								<Typography>
									<strong>Oposição:</strong> O usuário pode se opor à utilização de seus dados pessoais, desde que
									verificado inconformidade com a LGPD e observados os limites e imposições legalmente previstos.
								</Typography>
							</li>
							<li>
								<Typography>
									<strong>Informações sobre o compartilhamento:</strong> Sem prejuízo das informações fornecidas neste
									Aviso, o usuário pode solicitar esclarecimentos adicionais sobre o compartilhamento de seus dados
									pessoais.
								</Typography>
							</li>
							<li>
								<Typography>
									<strong>Revisão de decisões automatizadas:</strong> O usuário pode solicitar a revisão de decisões
									autônomas (sem participação humana) e/ou o fornecimento dos critérios e procedimentos adotados para a
									tomada dessas decisões.
								</Typography>
							</li>
							<li>
								<Typography>
									<strong>Solicitação junto à autoridade competente:</strong> Caso não seja possível exercer os direitos
									apresentados nesse tópico junto à Hypera, o usuário poderá encaminhar solicitação à Autoridade
									Nacional de Proteção de Dados (ANPD).
								</Typography>
							</li>
						</ul>

						<Typography>
							O exercício dos direitos relacionados no quadro acima depende de prévia solicitação do usuário e da
							inexistência de qualquer restrição técnica e/ou jurídica.
						</Typography>
						<Typography>
							Caso queira solicitar o exercício dos direitos relacionados ao uso de seus dados pessoais, entre em
							contato com nosso Encarregado por meio do canal: <a href="mailto:dpo@hypera.com.br">dpo@hypera.com.br</a>.
						</Typography>
					</Block>
				),
			},
			{
				label: 'Atualizações',
				content: (
					<Block>
						<Typography>
							Este Aviso poderá sofrer atualizações e ajustes a qualquer tempo. Caso haja atualização relevante,
							informaremos no Portal.
						</Typography>
						<Typography variant="Paragraph/Regular">
							<strong>Data da última atualização:</strong> 01/11/2023
						</Typography>
					</Block>
				),
			},
		],
	},
];
